var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLipstick = function SvgLipstick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.212 7.394c1.06-1.448 2.836-2.644 5.553-2.644.69 0 1.25.56 1.25 1.25v12.75h.867c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25V20c0-.69.56-1.25 1.25-1.25h.868v-7.531c0-.877.335-2.446 1.344-3.825m1.156 11.356h3.147V7.383c-1.116.258-1.822.854-2.286 1.487-.667.912-.861 1.953-.861 2.349zm-2.118 2.5v3.1h7.382v-3.1zm7.382 5.6H9.25v5.9h7.382zM22.28 20c0-.69.56-1.25 1.25-1.25H32c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25h-8.47c-.69 0-1.25-.56-1.25-1.25zm2.5 1.25v11.5h5.971v-11.5z",
    clipRule: "evenodd"
  })));
};
export default SvgLipstick;